
import { v4 as uuidv4 } from "uuid";
import { DataType, TicketType } from "@dndModels/Types";
import { ModelBase, PlayerObject } from "@models/UpsertableBase";

export class UserTicket extends PlayerObject {
  data_type: DataType = "user_ticket";
  ticket_type: TicketType = "Bug";
  subject = "";
  text = "";
  ticket: Ticket | null = null;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.ticket_type = obj.ticket_type ? obj.ticket_type : "Bug";
      this.subject = obj.subject ? obj.subject : "";
      this.text = obj.text ? obj.text : "";
    }
  }

  get_detail_format(): string {
    let detail = super.get_detail_format();
    detail = (detail.length > 0 ? `${detail}; ` : "") + `Ticket Type: ${this.ticket_type}`;
    return detail;
  }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      ticket_type: this.ticket_type,
      subject: this.subject,
      text: this.text,
    };
  }

  copy(copyMe: UserTicket, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.ticket_type = copyMe.ticket_type;
    this.subject = copyMe.subject;
    this.text = copyMe.text;
  }

  clone(drop_ids = false): UserTicket {
    const new_obj = new UserTicket();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export class Ticket extends ModelBase {
  data_type: DataType = "ticket";
  ticket_type: TicketType = "Bug";
  user_ticket_ids: string[] = [];
  status: "New" | "Assigned" | "In Progress" | "Awaiting Deploy" | "Complete" = "New";
  updates: TicketUpdate[] = [];
  user_tickets: UserTicket[] = [];

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.ticket_type = obj.ticket_type ? obj.ticket_type : "Bug";
      this.user_ticket_ids = obj.user_ticket_ids ? obj.user_ticket_ids : [];
      this.status = obj.status ? obj.status : "New";
      this.updates = obj.updates ? obj.updates.map((o: any) => new TicketUpdate(o)) : [];
    }
  }

  get_detail_format(): string {
    return `Ticket Type: ${this.ticket_type}; Status: ${this.status}`;
  }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      ticket_type: this.ticket_type,
      user_ticket_ids: this.user_ticket_ids,
      status: this.status,
      updates: this.updates.map(o => o.toDBObj()),
    };
  }

  copy(copyMe: Ticket, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.ticket_type = copyMe.ticket_type;
    this.user_ticket_ids = [...copyMe.user_ticket_ids];
    this.status = copyMe.status;
    this.updates = copyMe.updates.map(o => o.clone());
  }

  clone(drop_ids = false): Ticket {
    const new_obj = new Ticket();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export class TicketUpdate {
  id = "";
  text = "";
  
  constructor(obj?: any) {
    this.id = obj && obj.id ? obj.id : uuidv4().toString();
    if (obj) {
      this.text = obj.text ? obj.text : "";
    }
  }

  toDBObj(): any {
    return {
      id: this.id,
      text: this.text
    };
  }

  copy(copyMe: TicketUpdate): void {
    this.id = copyMe.id;
    this.text = copyMe.text;
  }

  clone(): TicketUpdate {
    const new_obj = new TicketUpdate();
    new_obj.copy(this);
    return new_obj;
  }
}